export default "__VITE_ASSET__CJ2o$6Au__"